// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "fuse-countdown{display:flex;flex-direction:row;align-items:center;justify-content:center}fuse-countdown .fuse-countdown{display:flex;flex-direction:row;align-items:center;justify-content:center;text-align:center}fuse-countdown .fuse-countdown .time{display:flex;flex-direction:column;padding:0 12px}fuse-countdown .fuse-countdown .time .value{font-size:34px;line-height:34px;padding-bottom:8px}fuse-countdown .fuse-countdown .time .title{color:rgba(0,0,0,.54)}", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();